import { z } from "zod";

/**
 * Wire schemas for the MCP OAuth endpoints (docs/brief-mcp-server.md §"Tier 4"). The consent
 * screen and the "Connected apps" card are the only browser-facing parts of the flow — the token
 * exchange happens between the MCP client and the API, never in this app.
 */

export const McpConsentInfoSchema = z.object({
	clientName: z.string(),
	redirectHost: z.string().nullable(),
	clientUri: z.string().nullable(),
	scopes: z.array(z.string()),
	userEmail: z.string(),
	companyName: z.string(),
	mcpAccessEnabled: z.boolean(),
});

export const McpConsentResultSchema = z.object({
	redirectUrl: z.string(),
});

export const McpConnectionSchema = z.object({
	clientId: z.string(),
	clientName: z.string(),
	clientUri: z.string().nullable(),
	connectedAt: z.string(),
	expiresAt: z.string(),
});

export const McpConnectionListSchema = z.array(McpConnectionSchema);

export type McpConsentInfo = z.infer<typeof McpConsentInfoSchema>;
export type McpConsentResult = z.infer<typeof McpConsentResultSchema>;
export type McpConnection = z.infer<typeof McpConnectionSchema>;
